/* @flow */
import * as React from 'react';

import PeopleListUserProfile from './PeopleListUserProfile';

export type PeopleListSidebarType = 'workflows' | 'batch' | 'profile';

type Props = {
  activeSidebar: PeopleListSidebarType,
};

export default function PeopleListSidebar(props: Props) {
  const { activeSidebar } = props;

  // Temporarily just render spans for sidebars
  return (
    <div>
      {activeSidebar === 'workflows' && <span data-test="workflows">Workflows</span>}
      {activeSidebar === 'batch' && <span data-test="batch">Batch</span>}
      {activeSidebar === 'profile' && <PeopleListUserProfile data-test="profile" />}
    </div>
  );
}
